import React, { useState } from 'react';

import { getAuth, sendPasswordResetEmail } from 'firebase/auth';
import { t } from 'i18next';


const PasswordRecoveryPage: React.FC = () => {

    const [loginEmail, setLoginEmail] = useState("");
    const [mailHasBeenSent, setEmailHasBeenSent] = useState(false);

    function onLoginFormSubmit(event) {
        event.preventDefault();

        sendPasswordResetEmail(getAuth(), loginEmail, {url: "https://patient-docgenda.web.app/login"})
        .then(()=>{
            setEmailHasBeenSent(true);
        })
        .catch((error) => {
            var errorCode = error.code;

            switch (errorCode) {
                case "auth/invalid-email":
                case "auth/user-not-found":
                    alert(t("pages.passwordRecoveryPage.invalidEmail"));
                    break;

                case "auth/user-disabled":
                    alert(t("pages.passwordRecoveryPage.accountIsLocked"));
                    break;

                default:
                    alert(error.message);
                    break;
            }

        });
    }

    return (

        <div className="kt-passwordRecoveryPage">

            <div className="kt-body">

                <div className="kt-panel">
                    <div className="kt-panel-content">

                        {mailHasBeenSent ?
                            <div>
                                <h2>{t("pages.passwordRecoveryPage.thankYou")}</h2>
                                <div>{t("pages.passwordRecoveryPage.youWillGetEmail")}</div>
                            </div>
                            :
                            <div>
                                <h2>{t("pages.passwordRecoveryPage.forgotYourPassword")}</h2>
                                <div>{t("pages.passwordRecoveryPage.resetPasswordHere")}</div>
                                <form name="login" onSubmit={onLoginFormSubmit}>
                                    <input type="email" placeholder={t("pages.passwordRecoveryPage.email")} required value={loginEmail} onChange={e => setLoginEmail(e.target.value)}/>

                                    <input className="kt-btn-big kt-btn-secondary-color" type="submit" value={t("components.buttons.reset").toUpperCase()} />
                                </form>
                            </div>
                        }

                        <div className="kt-history-back-link" onClick={e => window.history.back()}><i className="far fa-angle-left"></i> {t("components.buttons.back")}</div>

                    </div>
                </div>

            </div>

        </div>
    );
}

export default PasswordRecoveryPage;